var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.darkMode ? 'appDark' : 'app',attrs:{"id":"app"}},[_c('router-view',{on:{"dark":function($event){_vm.darkMode = !_vm.darkMode}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }